import React, { useContext, useMemo } from 'react'
import { withTranslationCustom } from 'lib/i18next'
import { SERVICE_EVENT_TYPE } from 'lib/utils/store/event'

import EventFormModule from 'components/Events/EventForm/EventFormModules/EventFormModule'
import CompactFormRow from 'components/Forms/CompactForm/CompactFormRow/CompactFormRow'
import { Field } from 'formik'
import Input from 'components/Forms/FormElements/Input'
import Select from 'components/Forms/FormElements/Select'
import { ExtendedFormikContext } from 'components/Forms/ExtendedFormik'

import './event-form-service-type-module.pcss'

const EventFormServiceTypeModule = ({ label, t }) => {
    const { values } = useContext(ExtendedFormikContext)

    const options = useMemo(() => [
        { value: SERVICE_EVENT_TYPE.ANNUAL_MAINTENANCE, name: t('events:serviceType.ANNUAL_MAINTENANCE') },
        { value: SERVICE_EVENT_TYPE.SCHEDULED_MAINTENANCE, name: t('events:serviceType.SCHEDULED_MAINTENANCE') },
        { value: SERVICE_EVENT_TYPE.OIL_CHANGE, name: t('events:serviceType.OIL_CHANGE') },
        { value: SERVICE_EVENT_TYPE.REPAIR, name: t('events:serviceType.REPAIR') },
        { value: SERVICE_EVENT_TYPE.TIRE_CHANGE, name: t('events:serviceType.TIRE_CHANGE') },
        { value: SERVICE_EVENT_TYPE.CAR_WASH, name: t('events:serviceType.CAR_WASH') },
        { value: SERVICE_EVENT_TYPE.OTHER, name: t('events:serviceType.OTHER') },
    ], [t])

    return (
        <EventFormModule className="event-form-service-type-module">
            <CompactFormRow
                iconName="wrench"
                label={label}
                trackName="serviceType"
            >
                <Field name="serviceType">
                    {(props) => (
                        <Select
                            {...props}
                            placeholder={t('events:forms.serviceType.placeholder')}
                            label=""
                            options={options}
                            size="s"
                        />
                    )}
                </Field>
                {values.serviceType === SERVICE_EVENT_TYPE.OTHER && (
                    <div className="event-form-service-type-module__other-text-container">
                        <Field
                            name="serviceTypeOtherText"
                            size="s"
                            placeholder="Muu tyyppi"
                            component={Input}
                        />
                    </div>
                )}
            </CompactFormRow>
        </EventFormModule>
    )
}

export default withTranslationCustom('events')(EventFormServiceTypeModule)
